import { hexToRgb } from './color.util'

const DEFAULT_INK = '#1A1A1A'
const INK_INDICES = [1, 5]

export function resolveInkAwarePalette(colors, slideTextColour) {
  const ink = slideTextColour && hexToRgb(slideTextColour) ? slideTextColour : DEFAULT_INK
  return colors.map((colour, index) => (INK_INDICES.includes(index) ? ink : colour))
}
